var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonMapService } from 'app/services/common-map.service';
import { CommonTableService } from 'app/services/common-table.service';
import { CommonTemplatesService } from 'app/services/common-templates.service';
import { EditService } from 'app/services/edit.service';
import { FieldMappingService } from 'app/services/field-mapping.service';
import { FishboneService } from 'app/services/fishbone.service';
import { GfoService } from 'app/services/gfo.service';
import { InterlayerCardService } from 'app/services/interlayer-card.service';
import { InterlayerDataService } from 'app/services/interlayer-data.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { UserService } from 'app/services/user.service';
import { CommonMapComponent } from '../common-map/common-map.component';
var ContentReportsComponent = /** @class */ (function () {
    function ContentReportsComponent(activityService, appinfoService, attrIndexService, tableService, commonService, commonTemplateService, iCardService, editService, fieldMappingService, fishboneService, gfoService, layerService, qcService, iDataService, mapControlsService, cMapService, iMapService, mapService, mapLayersService, mainDataService, mapSharedService, reportService, userService) {
        var _this = this;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.tableService = tableService;
        this.commonService = commonService;
        this.commonTemplateService = commonTemplateService;
        this.iCardService = iCardService;
        this.editService = editService;
        this.fieldMappingService = fieldMappingService;
        this.fishboneService = fishboneService;
        this.gfoService = gfoService;
        this.layerService = layerService;
        this.qcService = qcService;
        this.iDataService = iDataService;
        this.mapControlsService = mapControlsService;
        this.cMapService = cMapService;
        this.iMapService = iMapService;
        this.mapService = mapService;
        this.mapLayersService = mapLayersService;
        this.mainDataService = mainDataService;
        this.mapSharedService = mapSharedService;
        this.reportService = reportService;
        this.userService = userService;
        this.tabs = [];
        this.disableTabSwitching = false;
        this.tableId = 'mainDataTable';
        this.columns = [];
        this.rows = [];
        this.selectedRows = [];
        this.tableInfo = {};
        this.isMapFilterOn = false;
        this.mapSplitRatio = 50;
        this.mapElemId = 'report-map';
        this.bgTooltipElemId = 'report-map-tooltip';
        this.autoUuidCol = '_uniqueId'; // uuid col generated from code
        this.gqpColumnCol = 'gqp_column';
        this.onQcSelectFromMap = function (e) {
            var selected = e.selected[0];
            var featId = selected ? selected.getId() : null;
            var rec;
            if (featId) {
                _this.reportService.rows.find(function (r) { return _this.getAutoId(r) === featId; });
            }
            _this.reportService.selectedReportRecordsBS.next({
                rec: rec,
                source: 'map'
            });
        };
        this.onSelectOriginalDataFromMap = function (e) {
            var selected = e.selected[0];
            var featId = selected ? selected.getId() : null;
        };
        this.selectFromMapCondition = function () { };
        this.onMapContextmenu = function (e) { };
        this.onSelectRecFromTable = function (e) {
            _this.reportService.selectedReportRecordsBS.next({
                rec: _this.selectedRows[0],
                source: 'table'
            });
        };
        this.onTablePaging = function (pageNum) {
            _this.updateReport({
                pageNumber: pageNum
            });
        };
    }
    ;
    ContentReportsComponent.prototype.onChangeTab = function (e) {
        //
    };
    ContentReportsComponent.prototype.onPaneResize = function (e) {
        this.onResize();
    };
    ContentReportsComponent.prototype.clearReportData = function () {
        this.clearTableData();
        this.clearLayer(this.iMapService.qcLayerName);
        // this.clearMapData();
    };
    ContentReportsComponent.prototype.getAutoId = function (rec) {
        return rec[this.autoUuidCol];
    };
    // Check if qc error should draw
    ContentReportsComponent.prototype.checkWithinDrawResoQc = function (reso) {
        // TODO
        switch (this.selectedReport.type) {
            case 'FISHBONE':
                return reso < this.iMapService.mapDrawReso.fishbone;
        }
        return reso < 150;
    };
    // Check if subj/ref layer should draw
    ContentReportsComponent.prototype.checkWithinDrawResoBg = function (reso, cateCode) {
        var condition;
        switch (cateCode) {
            case this.attrIndexService.cateCodeAddress:
                condition = reso < this.mapLayersService.refLayerResolution[cateCode];
                break;
            case this.attrIndexService.cateCodeCenterline:
                condition = reso < this.mapLayersService.refLayerResolution[cateCode];
                break;
            case this.attrIndexService.cateCodeMatchPoint:
                // TODO
                break;
            default: // areas
                condition = reso < this.mapLayersService.refLayerReso_area;
                break;
        }
        return condition;
    };
    ContentReportsComponent.prototype.clearLayer = function (layerName) {
        this.iMapService.map.addedLayers[layerName].getSource().clear();
    };
    ContentReportsComponent.prototype.clearMapData = function () {
        this.clearLayer(this.iMapService.firstDataLayerName);
        this.clearLayer(this.iMapService.secondDataLayerName);
        this.clearLayer(this.iMapService.qcLayerName);
    };
    ContentReportsComponent.prototype.updateMapLayer = function (selectedReport) {
        if (!selectedReport) {
            return;
        }
        var dataLayer = this.iMapService.map.addedLayers[this.iMapService.firstDataLayerName];
        var secondLayer = this.iMapService.map.addedLayers[this.iMapService.secondDataLayerName];
        switch (selectedReport.type) {
            case 'FISHBONE':
                // dataLayer.setStyle(this.iMapService.getFishboneStyle)
                // TODO
                break;
            case 'OVERLAY':
                // TODO
                break;
            case 'BORDER':
                // TODO
                break;
        }
    };
    ContentReportsComponent.prototype.drawFishboneFromRsp = function (rsp) {
        return __awaiter(this, void 0, void 0, function () {
            var addressFeatures, spikeFeatures, routes, fishboneRoads, results, roadFeatures;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressFeatures = [];
                        spikeFeatures = [];
                        if (rsp && rsp.data) {
                            results = this.fishboneService.getFeaturesFromFishboneData(rsp.data);
                            addressFeatures = results.addressFeatures;
                            spikeFeatures = results.spikeFeatures;
                            routes = results.routes;
                        }
                        // Check cross bones for features
                        this.fishboneService.checkCrossBones(spikeFeatures);
                        return [4 /*yield*/, this.fishboneService.calcFishboneRoads(routes, true)];
                    case 1:
                        fishboneRoads = _a.sent(); // TODO: when to override the stored fishbone roads?????
                        // Fishbone roads are drawn inside the draw function
                        this.clearLayer(this.iMapService.qcLayerName);
                        // Styles // Spike style should be set AFTER cross/long bone check
                        addressFeatures.forEach(function (f) { return f.setStyle(_this.mapLayersService.getFishboneAddressLayerStyle); });
                        spikeFeatures.forEach(function (f) { return f.setStyle(_this.iMapService.getFishboneSpikeStyle); });
                        roadFeatures = this.fishboneService.drawFishboneRoads(this.iMapService.map.addedLayers[this.iMapService.secondDataLayerName], fishboneRoads);
                        roadFeatures.forEach(function (f) { return f.setStyle(_this.iMapService.getFishboneRoadStyle); });
                        // this.iMapService.map.addedLayers[this.iMapService.secondDataLayerName].getSource().addFeatures(addressFeatures);
                        // this.iMapService.map.addedLayers[this.iMapService.firstDataLayerName].getSource().addFeatures(spikeFeatures);
                        this.iMapService.map.addedLayers[this.iMapService.qcLayerName].getSource().addFeatures(addressFeatures);
                        this.iMapService.map.addedLayers[this.iMapService.qcLayerName].getSource().addFeatures(spikeFeatures);
                        return [2 /*return*/];
                }
            });
        });
    };
    // Draw qc wkt for reports (not fishbone)
    ContentReportsComponent.prototype.drawRecordsQc_other = function (recList) {
        var _this = this;
        if (!recList.length) {
            return;
        }
        var wktCol = Object.keys(recList[0]).find(function (c) { return c.endsWith('wkt'); });
        if (wktCol) {
            var layer = this.iMapService.map.addedLayers[this.iMapService.qcLayerName];
            var info = recList.map(function (i) {
                return {
                    wkt: i[wktCol],
                    id: _this.getAutoId(i),
                    props: i
                };
            });
            this.cMapService.drawDataByWkt(this.iMapService.map, info, layer, {
                skipZoomToLayer: true
            });
        }
    };
    // Highlight
    ContentReportsComponent.prototype.selectRecordsOnMap = function (ids, layer) {
        var _this = this;
        var select;
        var editLayer;
        layer = layer || this.iMapService.map.addedLayers[this.iMapService.qcLayerName];
        select = this.iMapService.qcSelectInteraction;
        editLayer = this.iMapService.map.addedLayers[this.iMapService.modifyLayerName];
        select.getFeatures().clear();
        var selectedFeats = [];
        ids.forEach(function (id) {
            var feat = layer.getSource().getFeatureById(id);
            if (!feat) {
                // Check if the record is on modify layer
                if (_this.isMapEditing) {
                    feat = editLayer.getSource().getFeatureById(id);
                }
            }
            if (feat) {
                select.getFeatures().push(feat);
                selectedFeats.push(feat);
            }
            else {
                console.log('No feature found with id: ' + id);
            }
        });
        return selectedFeats;
    };
    // private drawCenterlineFromRsp(rsp) {
    // 	console.log(rsp)
    // 	debugger
    // }
    ContentReportsComponent.prototype.onReportTypeChange = function (reportType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.selectedReportType = reportType;
                //
                if (reportType === 'FISHBONE') {
                    // Turn on mapfilter
                    if (!this.activityService.mapFilterBS.getValue().isOn) {
                        this.activityService.mapFilterBS.next({
                            isOn: true
                        });
                    }
                }
                this.reportService.reportTypeBS.next({
                    type: this.selectedReportType
                });
                return [2 /*return*/];
            });
        });
    };
    ContentReportsComponent.prototype.updateReport = function (paging, layerChange, backgroundOnly) {
        return __awaiter(this, void 0, void 0, function () {
            var olMap, reso, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearReportData();
                        if (!this.selectedReport) {
                            return [2 /*return*/];
                        }
                        if (this.isMapFilterOn) {
                            olMap = this.iMapService.map.olMap;
                            reso = olMap.getView().getResolution();
                            if (!this.checkWithinDrawResoQc(reso)) {
                                return [2 /*return*/];
                            }
                        }
                        else {
                            if (!paging) {
                                paging = {
                                    pageSize: this.tableService.defaultTableConfig.pageSize,
                                    rowCount: 1,
                                    pageNumber: 1
                                };
                            }
                            if (!paging.pageSize) {
                                paging.pageSize = this.tableService.defaultTableConfig.pageSize;
                            }
                        }
                        return [4 /*yield*/, this.getData(this.selectedReport, paging)];
                    case 1:
                        data = _a.sent();
                        if (data.dataStamp !== this.latestGetDataStamp) {
                            return [2 /*return*/];
                        }
                        this.setTable(data.rsp.data);
                        if (this.isMapFilterOn) {
                            this.totalCount = this.rows.length;
                        }
                        else {
                            if (data.rsp.totalCount || data.rsp.totalCount === 0) {
                                this.totalCount = data.rsp.totalCount;
                            }
                        }
                        if (!this.bgRefLayerCateCode) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateBgRefData()]; // TODO 
                    case 2:
                        _a.sent(); // TODO 
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContentReportsComponent.prototype.getData = function (report, paging) {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, latestStamp, spinnerId, customerId, qaCodes, gfo, addAutoId, olMap, extent, _a, _b, err_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        latestStamp = this.commonService.getRandomId();
                        this.latestGetDataStamp = latestStamp;
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 16, , 17]);
                        customerId = this.userService.getCustomerIdByType();
                        qaCodes = this.reportService.reportFilterInfoBS.getValue().filterOptions.filter(function (i) { return i.isSelected; }).map(function (i) { return i.value; });
                        if (!qaCodes.length) {
                            qaCodes = null;
                        }
                        gfo = void 0;
                        addAutoId = function (dataList) {
                            if (!dataList) {
                                return;
                            }
                            dataList.forEach(function (d) { return d[_this.autoUuidCol] = d[_this.attrIndexService.interlayerGlobalId1] + "_" + d[_this.attrIndexService.interlayerGlobalId2]; });
                        };
                        if (!this.isMapFilterOn) return [3 /*break*/, 10];
                        olMap = this.iMapService.map.olMap;
                        extent = olMap.getView().calculateExtent(olMap.getSize());
                        _a = report.type;
                        switch (_a) {
                            case 'FISHBONE': return [3 /*break*/, 2];
                            case 'OVERLAY': return [3 /*break*/, 5];
                            case 'BORDER': return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 9];
                    case 2: return [4 /*yield*/, this.fishboneService.getQrFishboneByMap(customerId, extent, qaCodes, gfo)];
                    case 3:
                        rsp = _c.sent();
                        addAutoId(rsp.data);
                        // Subject layer // For fishbone, Both qc and subject data are drawn in subject layer
                        return [4 /*yield*/, this.drawFishboneFromRsp(rsp)];
                    case 4:
                        // Subject layer // For fishbone, Both qc and subject data are drawn in subject layer
                        _c.sent();
                        return [3 /*break*/, 9];
                    case 5: return [4 /*yield*/, this.reportService.getQrOverlay(this.selectedReport.subjectLayerId, this.selectedReport.refLayerId, qaCodes, extent)];
                    case 6:
                        rsp = _c.sent();
                        addAutoId(rsp.data);
                        this.drawRecordsQc_other(rsp.data);
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.reportService.getQrOther(this.selectedReport.subjectLayerId, this.selectedReport.refLayerId, qaCodes, extent)];
                    case 8:
                        // const subjFeatures = await this.updateDataInMapView(report.subjectLayerCate, report.subjectLayerId, this.iMapService.dataLayerName);
                        rsp = _c.sent();
                        addAutoId(rsp.data);
                        this.drawRecordsQc_other(rsp.data);
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 15];
                    case 10:
                        _b = report.type;
                        switch (_b) {
                            case 'OVERLAY': return [3 /*break*/, 11];
                            case 'BORDER': return [3 /*break*/, 13];
                        }
                        return [3 /*break*/, 15];
                    case 11: return [4 /*yield*/, this.reportService.getQrOverlay(this.selectedReport.subjectLayerId, this.selectedReport.refLayerId, qaCodes, null, paging)];
                    case 12:
                        rsp = _c.sent();
                        addAutoId(rsp.data);
                        return [3 /*break*/, 15];
                    case 13: return [4 /*yield*/, this.reportService.getQrOther(this.selectedReport.subjectLayerId, this.selectedReport.refLayerId, qaCodes, null, paging)];
                    case 14:
                        rsp = _c.sent();
                        addAutoId(rsp.data);
                        return [3 /*break*/, 15];
                    case 15: return [3 /*break*/, 17];
                    case 16:
                        err_1 = _c.sent();
                        console.log(err_1);
                        return [3 /*break*/, 17];
                    case 17:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/, {
                                dataStamp: latestStamp,
                                rsp: rsp
                            }];
                }
            });
        });
    };
    ContentReportsComponent.prototype.updateBgRefData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layers, layerInfo, refFeatures;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layers = this.layerService.layerListBS.getValue().layers;
                        layerInfo = layers.find(function (l) { return l.category.code === _this.bgRefLayerCateCode; });
                        if (!layerInfo || !layerInfo.id) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.updateDataInMapView(this.bgRefLayerCateCode, layerInfo.id, this.iMapService.backgroundRefLayerName)];
                    case 1:
                        refFeatures = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // TODO
    // private async getRecordsDetail(globalIds: any[], globalIdCol, layerId) {
    // 	if (!globalIds) {
    // 		return;
    // 	}
    // 	const filter = this.gfoService.getFilter(globalIdCol, this.appinfoService.filterOperators.eq.name, globalId);
    // 	const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
    // 	const rsp = await this.layerService.getLayerContents(layerId, gfo);
    // 	return rsp[0];
    // }
    ContentReportsComponent.prototype.getFeaturesInMapView = function (layerIdCol, layerId, sourceTable, attrList, sql, primaryKey, featIdCol) {
        return __awaiter(this, void 0, void 0, function () {
            var map, vtLayer, vtSource, tileGrid, ext, zoom, layerIdFilter, results, features, featById_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        map = this.iMapService.map;
                        vtLayer = map.addedLayers[this.mapLayersService.vectorTileRefLayerName];
                        vtSource = vtLayer.getSource();
                        tileGrid = vtSource.getTileGrid();
                        ext = map.olMap.getView().calculateExtent();
                        zoom = Math.floor(map.olMap.getView().getZoom());
                        if (Array.isArray(layerId)) {
                            layerIdFilter = this.gfoService.getFilter(layerIdCol, this.appinfoService.filterOperators.in.name, layerId);
                        }
                        else {
                            layerIdFilter = this.gfoService.getFilter(layerIdCol, this.appinfoService.filterOperators.eq.name, layerId);
                        }
                        return [4 /*yield*/, this.mapService.getFeaturesFromTileGrid(tileGrid, ext, zoom, sourceTable, [layerIdFilter], attrList, sql, primaryKey)];
                    case 1:
                        results = _a.sent();
                        features = results.features;
                        // Filter features with unique id // Because line/polygon features might appear cross tiles and thus obtained more than once, we need to filter out duplicates
                        if (featIdCol) {
                            featById_1 = {};
                            features.forEach(function (f) {
                                var id = f.getProperties()[featIdCol];
                                if (id || id === 0) {
                                    f.setId(id);
                                    featById_1[id] = f;
                                }
                            });
                            features = Object.keys(featById_1).map(function (id) { return featById_1[id]; });
                        }
                        return [2 /*return*/, {
                                features: features,
                                isSample: results.isSample
                            }];
                }
            });
        });
    };
    ContentReportsComponent.prototype.updateDataInMapView = function (cateCode, layerId, layerName, extraAttrList) {
        return __awaiter(this, void 0, void 0, function () {
            var layer, info, idCol, attrList, rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layer = this.iMapService.map.addedLayers[layerName];
                        info = this.editService.layerInfo[cateCode];
                        idCol = info.prefix + '_' + this.attrIndexService.globalIdColStandard;
                        attrList = idCol;
                        if (extraAttrList) {
                            attrList += ',' + extraAttrList;
                        }
                        return [4 /*yield*/, this.getFeaturesInMapView(info.layerIdCol, layerId, info.sourceTable, attrList, null, null, idCol)];
                    case 1:
                        rsp = _a.sent();
                        layer.getSource().clear();
                        layer.getSource().addFeatures(rsp.features);
                        return [2 /*return*/, rsp.features];
                }
            });
        });
    };
    ContentReportsComponent.prototype.setTable = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var columns, hides, hideContains, nguidCol;
            var _this = this;
            return __generator(this, function (_a) {
                if (!data || !data.length) {
                    this.clearTableData();
                    return [2 /*return*/];
                }
                columns = this.tableService.setColumnsFromRows(data);
                hides = [this.attrIndexService.qaNotesColName, this.gqpNoteCol, 'labels_qc'];
                hideContains = ['_wkt', "_" + this.attrIndexService.globalIdColStandard, this.autoUuidCol];
                hides.forEach(function (i) {
                    var colIdx = columns.findIndex(function (c) { return c.prop.toLowerCase() === i.toLowerCase(); });
                    if (colIdx > -1) {
                        columns.splice(colIdx, 1);
                    }
                });
                hideContains.forEach(function (i) {
                    columns = columns.filter(function (c) { return !c.prop.toLowerCase().includes(i.toLowerCase()); });
                });
                //
                columns.forEach(function (c) {
                    c.headerTemplate = _this.headerTempl;
                    if (c.prop === _this.gqpColumnCol) {
                        c.cellTemplate = _this.gqpColumnTempl;
                        var fixedClass_1 = _this.tableService.fixedCellClassToString(c.info.fixedCellClass);
                        var qcFilterOptions_1 = _this.reportService.reportFilterInfoBS.getValue().filterOptions;
                        c.cellClass = function (event) {
                            var cellClass = fixedClass_1;
                            var note = event.row[_this.attrIndexService.qaNotesColName];
                            if (note && qcFilterOptions_1.length) {
                                var qcCellClass = _this.qcService.getQcCellClassName([note], null, c.prop, qcFilterOptions_1);
                                if (qcCellClass) {
                                    cellClass += ' ' + qcCellClass;
                                }
                            }
                            return cellClass;
                        };
                    }
                    // Tooltip
                    var prefix = c.prop.split('_')[0];
                    var cate = _this.appinfoService.layerTypeList.find(function (t) { return t.colPrefix === prefix; });
                    if (prefix && cate) {
                        var standardCol = cate.standardCols.find(function (sCol) { return prefix + "_" + sCol.colName.toLowerCase() === c.prop; });
                        if (standardCol) {
                            c.info.tooltip = standardCol.htmlTooltip;
                        }
                    }
                });
                nguidCol = columns.find(function (c) { return c.prop.toLowerCase().endsWith(_this.attrIndexService.nguidCol.toLowerCase()); });
                if (nguidCol) {
                    nguidCol.cellTemplate = this.commonTemplateService.nguidCellTemplate;
                    nguidCol.info.skipSmartDisplay = true;
                    nguidCol.width = 40;
                    this.tableService.moveColToFront(columns, nguidCol.prop);
                }
                this.setRows(data);
                this.setColumns(columns);
                return [2 /*return*/];
            });
        });
    };
    ContentReportsComponent.prototype.setRows = function (data) {
        this.rows = data;
        this.reportService.rows = this.rows;
    };
    ContentReportsComponent.prototype.setColumns = function (data) {
        this.columns = data;
    };
    ContentReportsComponent.prototype.clearTableData = function () {
        this.setColumns([]);
        this.setRows([]);
        this.selectedRows = [];
    };
    // Add/Remove selection to table
    ContentReportsComponent.prototype.selectRecordOnTable = function (id) {
        // let rowIdx = -1;
        // const selected = [];
        // if (id || id === 0) {
        // 	if (this.selectedReport.type !== 'FISHBONE') {
        // 		rowIdx = this.rows.findIndex(r => this.getAutoId(r) === id);
        // 	} else {
        // 		if (fishboneIdType === 'centerline') {
        // 			rowIdx = this.rows.findIndex(r => r[this.rcUuidCol2] && r[this.rcUuidCol2].indexOf(id) > -1);
        // 		} else if (fishboneIdType === 'addr') {
        // 			rowIdx = this.rows.findIndex(r => r[this.addrUuidCol] === id);
        // 		} else {
        // 			rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
        // 		}
        // 	}
        // 	if (rowIdx === -1 && this.isMapFilterOn) { // If map filter is on, the selected row might be in other pages
        // 		const rowsAllIdx = this.rowsAll.findIndex(r => this.getRecordId(r) === id);
        // 		if (rowsAllIdx > -1) {
        // 			const row = this.rowsAll[rowsAllIdx];
        // 			// this.rows = [row].concat(this.rows);
        // 			this.setRows([row].concat(this.rows));
        // 			rowIdx = 0;
        // 			// Keep the row in rowsAll at the same position as in rows
        // 			this.rowsAll.splice(rowsAllIdx, 1);
        // 			this.rowsAll.unshift(row);
        // 			// const pageNum = this.getPageNumByRowIdx(rowsAllIdx);
        // 			// this.dataTable.reset(pageNum, this.dataTable.totalNum);
        // 			// const rows = this.getRowsByPageNum(pageNum);
        // 			// this.setRows(rows);
        // 			// rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
        // 		}
        // 	}
        // }
        // if (rowIdx > -1) {
        // 	selected.push(this.rows[rowIdx]);
        // 	this.dataTable.scrollRowIntoView(rowIdx, this.rows.length);
        // }
        // this.selectedRows = selected;
    };
    ContentReportsComponent.prototype.initTabs = function () {
        var filterOptionTab = {
            key: 'filterOptions',
            label: 'Filter',
            template: this.tabReportFilterTemp
        };
        var dataSbjTab = {
            key: 'data-sbj',
            label: 'Data',
            template: this.tabDataTemp,
            hidden: true
        };
        var dataRefTab = {
            key: 'data-ref',
            label: 'Data',
            template: this.tabDataRefTemp,
            hidden: true
        };
        var exceptionTab = {
            key: 'exception',
            label: 'Exception',
            template: this.tabExceptionTemp
        };
        this.tabs = [filterOptionTab, dataSbjTab, dataRefTab, exceptionTab];
    };
    ContentReportsComponent.prototype.updateDataTabLabels = function () {
        var _this = this;
        var dataSbjTab = this.tabs.find(function (t) { return t.key === 'data-sbj'; });
        var dataRefTab = this.tabs.find(function (t) { return t.key === 'data-ref'; });
        var refCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === _this.selectedReport.refLayerCate; });
        var subCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === _this.selectedReport.subjectLayerCate; });
        dataSbjTab.label = subCate.nameShort;
        dataRefTab.label = refCate.nameShort;
    };
    ContentReportsComponent.prototype.initTable = function () {
        this.pageSize = this.tableService.defaultTableConfig.pageSize;
        this.tableInfo.onPaging = this.onTablePaging;
        this.tableInfo.onSelect = this.onSelectRecFromTable;
        this.tableInfo.onScroll = function (e) { };
    };
    ContentReportsComponent.prototype.initMapParams = function () {
        this.mapParamsConfig = {
            minReso: this.mapSharedService.minReso,
            center: this.mapSharedService.mapViewCenter,
            reso: this.mapSharedService.mapViewReso
        };
    };
    ContentReportsComponent.prototype.initMap = function () {
        var map = this.iMapService.map;
        var zIndex = 0;
        this.mapLayersService.addRefVectorTileLayer(map, zIndex++);
        this.iMapService.addBackgroundRefLayer(map, zIndex++);
        this.iMapService.addSecondDataLayer(map, zIndex++);
        this.iMapService.addDataLayer(map, zIndex++);
        this.iMapService.addQcDataLayer(map, zIndex++);
        this.iMapService.addDataModifyLayer(map, zIndex++);
        this.iMapService.addSelectInteraction(this.onQcSelectFromMap, this.onSelectOriginalDataFromMap);
        this.addMapListeners();
    };
    ContentReportsComponent.prototype.addMapListeners = function () {
        var _this = this;
        var olMap = this.iMapService.map.olMap;
        this.iMapService.map.baseMapLayerGroup.setOpacity(this.mapSharedService.initBasemapOpacity);
        olMap.on('movestart', function () {
            if (_this.mapMoveTimeout) {
                clearTimeout(_this.mapMoveTimeout);
            }
        });
        olMap.on('moveend', function (e) {
            if (_this.mapMoveTimeout) {
                clearTimeout(_this.mapMoveTimeout);
            }
            _this.iMapService.mapMoveendSubject.next(); // TODO???????
            _this.mapMoveTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var reso, report_1, subjFeatures, extraAttrs, refCate, refFeatures;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            reso = olMap.getView().getResolution();
                            // Store current view
                            this.mapSharedService.mapViewReso = reso;
                            this.mapSharedService.mapViewCenter = olMap.getView().getCenter();
                            if (!this.selectedReport) return [3 /*break*/, 4];
                            report_1 = this.selectedReport;
                            if (!(this.selectedReport.type !== 'FISHBONE')) return [3 /*break*/, 2];
                            if (!this.checkWithinDrawResoBg(reso, report_1.subjectLayerCate)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateDataInMapView(report_1.subjectLayerCate, report_1.subjectLayerId, this.iMapService.firstDataLayerName)];
                        case 1:
                            subjFeatures = _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!this.checkWithinDrawResoBg(reso, report_1.refLayerCate)) return [3 /*break*/, 4];
                            extraAttrs = '';
                            refCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === report_1.refLayerCate; });
                            if (refCate && refCate.geomType === 'AREA') {
                                extraAttrs = this.attrIndexService.bdryColorCol;
                            }
                            return [4 /*yield*/, this.updateDataInMapView(report_1.refLayerCate, report_1.refLayerId, this.iMapService.secondDataLayerName, extraAttrs)];
                        case 3:
                            refFeatures = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!this.isMapFilterOn) return [3 /*break*/, 6];
                            return [4 /*yield*/, this.updateReport()];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, _this.mapService.moveWaitTime);
        });
        olMap.on('pointermove', function (e) {
            // TODO
        });
    };
    ContentReportsComponent.prototype.onResize = function () {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(function () {
            // TODO
        }, 200);
    };
    ContentReportsComponent.prototype.getRecordDetail = function (id, idCol, layerId, isRefLayer) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, gfo, rsp, data, dataIndex, attrs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) {
                            return [2 /*return*/];
                        }
                        filter = this.gfoService.getFilter(idCol, this.appinfoService.filterOperators.eq.name, id);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.layerService.getLayerContents(layerId, gfo)];
                    case 1:
                        rsp = _a.sent();
                        data = rsp.data;
                        dataIndex = isRefLayer ? this.iDataService.refDataIndex : this.iDataService.sbjDataIndex;
                        if (data && data[0]) {
                            dataIndex.addDataToStoredRecords(data, idCol);
                            dataIndex.setDataAttrs(id, this.attrIndexService.isIdOnlyKey, false);
                            attrs = dataIndex.getDataAttrs(id);
                            return [2 /*return*/, attrs];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContentReportsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isInit = true;
        this.defaultGutterSize = this.attrIndexService.defaultGutterSize;
        this.gqpNoteCol = this.attrIndexService.interlayerNoteCol;
        this.mainDataService.contentMenuItemKeyBS.next('report');
        this.initTable();
        this.initMapParams();
        this.reportSub = this.reportService.selectedReportBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var cates;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isInit) {
                            return [2 /*return*/];
                        }
                        this.selectedReport = data;
                        this.clearMapData();
                        // Update bgRefLayerCateCode
                        if (this.selectedReport) {
                            if (this.selectedReport.subjectLayerCate === this.attrIndexService.cateCodeCenterline && this.selectedReport.refLayerCate !== this.attrIndexService.cateCodeAddress) {
                                this.bgRefLayerCateCode = this.attrIndexService.cateCodeAddress;
                            }
                            else if (this.selectedReport.refLayerCate === this.attrIndexService.cateCodeCenterline && this.selectedReport.subjectLayerCate !== this.attrIndexService.cateCodeAddress) {
                                this.bgRefLayerCateCode = this.attrIndexService.cateCodeAddress;
                            }
                            else {
                                this.bgRefLayerCateCode = null;
                            }
                        }
                        else {
                            this.bgRefLayerCateCode = null;
                        }
                        if (!this.selectedReport) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.reportService.updateQrFilterOptions(this.selectedReport.type, this.selectedReport.subjectLayerId, this.selectedReport.refLayerId)];
                    case 1:
                        _a.sent();
                        this.updateDataTabLabels();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.reportService.updateQrFilterOptions(null, null, null)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(this.selectedReport && this.selectedReport.type !== this.selectedReportType)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.onReportTypeChange(this.selectedReport.type)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        // Update schema
                        if (this.selectedReport) {
                            cates = [this.selectedReport.subjectLayerCate, this.selectedReport.refLayerCate];
                            cates.forEach(function (cate, idx) { return __awaiter(_this, void 0, void 0, function () {
                                var layerType, standardSchema;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            layerType = this.appinfoService.layerTypeList.find(function (t) { return t.code === cate; });
                                            // update stored prefix
                                            if (idx === 0) {
                                                this.iCardService.sbjPrefix = layerType.colPrefix;
                                            }
                                            else if (idx === 1) {
                                                this.iCardService.refPrefix = layerType.colPrefix;
                                            }
                                            standardSchema = layerType.standardCols;
                                            if (!!standardSchema) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.fieldMappingService.getStandardSchema(layerType.id)];
                                        case 1:
                                            standardSchema = _a.sent();
                                            layerType.standardCols = standardSchema;
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        // Update map layer
                        this.updateMapLayer(data);
                        // Update data
                        return [4 /*yield*/, this.updateReport(null, true)];
                    case 7:
                        // Update data
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.reportListSub = this.reportService.reportListBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data) {
                            return [2 /*return*/];
                        }
                        if (!(this.selectedReportType !== data.reportType)) return [3 /*break*/, 2];
                        // // Update qa rules
                        // await this.reportService.updateQrFilterOptions(data.reportType, this.selectedReport.subjectLayerId, this.selectedReport.refLayerId);
                        return [4 /*yield*/, this.onReportTypeChange(data.reportType)];
                    case 1:
                        // // Update qa rules
                        // await this.reportService.updateQrFilterOptions(data.reportType, this.selectedReport.subjectLayerId, this.selectedReport.refLayerId);
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.requestDataSub = this.reportService.requestData.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateReport(null, data.layerChange)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.mapFilterSub = this.activityService.mapFilterBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isMapFilterOn !== data.isOn)) return [3 /*break*/, 2];
                        this.isMapFilterOn = data.isOn;
                        if (!!isInit) return [3 /*break*/, 2];
                        if (this.isMapFilterOn) {
                            // TODO: clear map
                        }
                        return [4 /*yield*/, this.updateReport()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.selectedRecordSub = this.reportService.selectedReportRecordsBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); });
        this.zoomToRecordSub = this.mapControlsService.zoomToRecordSubject.subscribe(function () { return __awaiter(_this, void 0, void 0, function () {
            var selectedFeat;
            return __generator(this, function (_a) {
                selectedFeat = this.iMapService.qcSelectInteraction.getFeatures().getArray()[0];
                if (selectedFeat) {
                    this.iMapService.map.zoomToFeature(selectedFeat, {
                        minReso: this.cMapService.zoomToLayerMinReso
                    });
                }
                return [2 /*return*/];
            });
        }); });
        isInit = false;
    };
    ContentReportsComponent.prototype.ngAfterViewInit = function () {
        this.iMapService.map = this.mapComponent.map;
        this.iMapService.mapBS.next(this.mapComponent.map);
        this.initMap();
        this.initTabs();
    };
    ContentReportsComponent.prototype.ngOnDestroy = function () {
        // this.activityService.mapFilterBS.next({
        // 	isOn: this.isMapFilterOn,
        // 	disabled: false
        // });
        this.reportService.reportTypeBS.next(null);
        this.mapFilterSub.unsubscribe();
        this.reportSub.unsubscribe();
        this.reportListSub.unsubscribe();
        this.requestDataSub.unsubscribe();
        this.selectedRecordSub.unsubscribe();
        this.zoomToRecordSub.unsubscribe();
    };
    return ContentReportsComponent;
}());
export { ContentReportsComponent };
